// extracted by mini-css-extract-plugin
export default {"list":"ListContainer_list__+J76Z","completedActions":"ListContainer_completedActions__aZaJc"};